import {
    ContactModel,
    EmployeeModel,
    Project,
} from '../../../../domain/projects/project';
import CitySelector from '../../../cities/components/CitySelector';
import { CustomerContactsAddList } from '../../../customer-contacts/components/CustomerContactsAddList';
import CustomerSelector from '../../../customers/components/CustomerSelector';
import { EmployeeAddList } from '../../../employees/components/EmployeeAddList';
import ProductSelector from '../../../products/components/ProductsSelector';
import TextField from '../../../shared/components/forms/TextField';

interface Props {
    project: Project;
    onChange: (
        name: string,
        value:
            | string
            | boolean
            | number[]
            | number
            | undefined
            | EmployeeModel[]
            | ContactModel[]
    ) => void;

    onFiltersChange: (name: string, selectedIds: number[]) => void;
}

export default function ProjectDetailsSection({
    project,
    onChange: handleInputChange,
    onFiltersChange,
}: Props) {
    return (
        <>
            <h5 className='mb-3'>Datos Personales</h5>
            <div className='col-6'>
                <TextField
                    label='Nombre Proyecto *'
                    name='name'
                    onChange={handleInputChange}
                    required={true}
                    value={project.name}
                    key='name'
                />
            </div>
            <div className='col-6'>
                <CitySelector
                    name='cityId'
                    onChange={handleInputChange}
                    value={project.cityId}
                />
            </div>
            <div className='col-6'>
                <CustomerSelector
                    name='customerId'
                    onChange={handleInputChange}
                    value={project.customerId}
                    label='Cliente *'
                />
            </div>
            <div className='col-6'>
                <ProductSelector
                    name='productId'
                    onChange={handleInputChange}
                    value={project.productId}
                />
            </div>
            {project.customerId > 0 && (
                <div className='col-6'>
                    <CustomerContactsAddList
                        onChange={(e) => handleInputChange('customerContacts', e)}
                        key='customerContacts'
                        name='customerContacts'
                        value={project.customerContacts}
                        customerId={project.customerId}
                    />
                </div>
            )}
            <div className='col-6'>
                <EmployeeAddList
                    onChange={(e) => handleInputChange('employees', e)}
                    key='employees'
                    name='employees'
                    value={project.employees}
                />
            </div>
        </>
    );
}
